import { LANGS } from '@/i18n'
import { useI18n } from '@/contexts/I18nContext'

export const LanguageSwitcher = () => {
  const { lang, setLang, t } = useI18n()

  return (
    <div
      className="flex items-center rounded-lg border border-gray-200 bg-gray-50 p-0.5"
      role="group"
      aria-label={t('layout.language')}
      title={t('layout.language')}
    >
      {LANGS.map((l) => (
        <button
          key={l.code}
          type="button"
          onClick={() => setLang(l.code)}
          aria-pressed={lang === l.code}
          className={`px-2 py-1 text-xs font-semibold rounded-md transition-colors ${
            lang === l.code
              ? 'bg-white text-primary-700 shadow-sm ring-1 ring-gray-200'
              : 'text-gray-500 hover:text-gray-700'
          }`}
        >
          {l.label}
        </button>
      ))}
    </div>
  )
}

export default LanguageSwitcher
